/**
 * Store de clusters
 * --------------------------------------------
 *
 * contiene la store de clusters
 *
 */
import { getClustersUser } from "@/utils/ClusterService.js";
import { getListSensors, getListSolarHubs } from "@/utils/SolarHubService.js";

export default {
  namespaced: true,
  state: {
    idCluster: 0,
    currentCluster: {},
    clustersUser: {},
    sensorsList: {},
  },
  mutations: {
    updateCurrentCluster(state, payload) {
      state.currentCluster = payload;
    },

    updateUserClusters(state, payload) {
      state.clustersUser = payload;
    },
    updateSensors(state, payload) {
      state.sensorsList = payload;
    },
  },
  actions: {
    /**
     * actualiza el cluster actual a partir de id del cluster
     */
    async actionUpdateCluster({ commit }, idx) {
      const cluster = await getListSolarHubs(idx);
      commit("updateCluster", cluster);
      commit("updateIdCluster", cluster[0].cluster.id);
    },
    /**
     * carga todos los clusters del usuario
     */
    async loadUserClusters({ commit }) {
      const clustersUserData = await getClustersUser();
      commit("updateUserClusters", clustersUserData);
    },
    loadCurrentCluster({ commit }, cluster) {
      commit("updateCurrentCluster", cluster);
    },
    /**
     * obtiene los sensores del solarhub del cluster seleccionado
     */
    async actionUpdateSensors({ commit }, { idCluster, idSolarHub }) {
      const sensorsListData = await getListSensors(idCluster, idSolarHub);
      commit("updateSensors", sensorsListData);
    },
  },
  getters: {},
};
